export const CA1 = {

  //Generic

  saveSuccess: "Desament realitzat correctament!",
  saveError: "Error en desar!",
  cancel: "Cancel·la",
  accept: "Accepta",
  next: "Següent",
  previous: "Anterior",
  required: "Aquest és un camp obligatori",
  exit: "Surt",
  search: "Cerca",
  news: "Novetats",
  send: "Envia",
  reSend: "Reenvia",
  create: "Crea",
  add: "Afegeix",
  delete: "Esborra",
  update: "Actualitza",
  yes: "Sí",
  no: "No",
  save: "Desa",
  correosId: "Correos ID",
  genericError: "S’ha produït un error",
  change: "Canvia",
  see: "Mostra",
  download: "Baixa",
  address: "Adreça",
  email: "Email",
  phone: "Teléfono",
  idDocument: "Documento identificativo",
  country: "País",
  province: "Província",
  city: "Ciutat",
  postalCode: "Codi postal",
  reset: "Inicialitza",
  pending: "Pendiente",
  done: "Hecho",
  here: "aquí",
  backToTheApp: "Volver a la aplicación",
  selectOption: "Selecciona una opción",
  noOptionSelected: "Sin seleccionar",
  close: "Tancar",
  copy: "Copiar",

  // PendingData

  valid: "Válido",
  document: "Documento",
  userAddress: "Dirección de usuario",
  enterpriseAddress: "Dirección de empresa",
  privacySign: "Firma de privacidad",
  tycSign: "Firma de Términos y Condiciones",
  pendingData: "Tienes datos pendientes:",

  //login

  logInTitle: "Inicia sesión",
  sublogInTitle: "Accede a {appName} a través de Correos ID. ",
  sublogInTitleCID: "Accede a Correos ID. ",
  sublogInTitleInfo: "Si ya estás registrado, no tendrás que volver a registrarte.",
  sublogInTitleInfoCID: "Desde aquí puedes manejar tu identidad de correos.",
  logInTitleSelectType: "¿Cómo quieres acceder?",
  logInTitleSelectEmail: "Si ya tienes cuenta, accede con tu email",
  correosIdentityLabel: "Identitat de Correos",
  correosPasswordLabel: "Contrasenya",
  correosCheckPasswordLabel: "Confirmación contraseña",
  loginTooltip: "Correos ID es la puerta de entrada a los servicios digitales de Correos. Para acceder a ellos, solamente debes introducir tus credenciales, no tendrás que volver a registrarte.",
  forgotPasswordButton: "Heu oblidat la contrasenya?",
  nextButton: "Següent",
  logInButton: "Inicia sessió",
  userPasswordError: "Usuari o contrasenya incorrectes",
  warningLegal: "Avís legal",
  privacyPolicy: "Política de privacitat",
  cookiesPolicy: "Política de galetes",
  createAccountButton: "Crea un compte",
  rememberme: "Recorda’m",
  welcomeBack: "Hola de nou",
  recoverDisabledAccount1:
    "S’ha bloquejat el vostre compte. Si voleu tornar a activar el compte i recuperar la vostra informació, cliqueu ",
  recoverDisabledAccount2: "l’enllaç següent",
  recoverDisabledAccount3: " per iniciar el procés de recuperació de compte.",
  loginPrivacyDialogTitle: "Privacitat",
  loginPrivacyDialogText:
    "Per poder accedir a l’aplicació, abans heu d’acceptar la privacitat",
  loginSubscribeDialogTitle: "Suscripción",
  loginSubscribeDialogText: "No estás suscrito a la aplicación, si quieres suscribirte debes leer y aceptar los términos y condiciones y pulsar en aceptar",
  loginSubscribeDialogTextServices: "Para poder suscribirte primero debes leer y aceptar los términos y condiciones y pulsar en aceptar",
  InvitationAcceptSuccess: "Invitación aceptada",
  AcceptChangeEnterpriseRoleSuccess: "Cambio de rol aceptado con éxito",
  CancelOrRejectChangeRoleSuccess: "Se ha rechazado la invitación",
  InvitationAcceptError: "La invitación ha fallado",
  AcceptChangeEnterpriseRoleError: "Ha fallado el cambio de rol",
  CancelOrRejectChangeRoleError: "Ha fallado el rechazo de la invitación",
  loginSystemUserError: "Un usuario de sistema no puede loguear en la web",
  footerCopyrightText: "©Sociedad Estatal Correos y Telegrafos, S.A., S.M.E. Todos los derechos reservados.",
  loginFormatError: "Formato incorrecto",
  loginOauthError: "El método oauth ya no está disponible",

  //Register

  loginPageInfo: "¿Aún no tienes una cuenta? ",
  loginPageRegistryHere: "Regístrate aquí",
  registerPagePutData: "Introduce los datos de registro",
  registerPageConfirmIdentity: "Verifica tu identidad",
  registerPageMail: "Adreça electrònica",
  registerPageMailError: "L’adreça electrònica introduïda no és correcta",
  registerPagePhoneError: "El telèfon introduït no és correcte",
  registerPageNDOError: "El document introduït no és correcte",
  registerPageMailErrorExist:
    "L’adreça electrònica introduïda ja està registrada",
  registerPagePassword: "Contrasenya",
  registerPagePasswordError:
    "8-16 caràcters, que continguin tres dels quatre següents: minúscules, majúscules, dígits (0-9) i un o més dels símbols següents: @ # $ % ^ & * - _ + = [ ] { } | \\ : ' , ? / ` ~ ( ) ; . \"",
  registerPageCheckPassword: "Confirmació",
  registerPageCheckPasswordError: "Les contrasenyes no són iguals",
  registerPagePhone: "Telèfon",
  registerPagePhoneErrorShort: "El telèfon és massa curt",
  registerPagePhoneErrorLong: "El telèfon és massa llarg",
  registerPagePhoneErrorExist: "El telèfon introduït ja està registrat",
  registerPagePrefixError: "Tiene que introducir un prefijo",
  registerPageTipoPersona: "Tipus de persona",
  registerPageAgreeConditionsPhrase: "Debes leer y aceptar los términos y condiciones: ",
  registerPageAgreeConditions: "Termes i condicions",
  registerPageAgreeConditionsDot: "Términos y Condiciones: ",
  registerPageAgreeConditionsSee: "Ver Términos y Condiciones",
  registerPageAgreeConditionsTerms1: "He llegit i accepto ",
  registerPageAgreeConditionsTerms2: "les condicions d’ús ",
  registerPageAgreeConditionsTerms3: " de {appName}.",
  registerPageAgreeConditionsTerms4: "Política de protecció de dades",
  registerPageAgreeConditionsAccepted: "Aceptados",
  registerPageAgreeConditionsPending: "Pendiente *",
  registerPageAgreeConditionsTermsConsent:
    "D’acord amb la nostra Política de protecció de dades ens agradaria actualitzar el vostre consentiment per a les activitats següents:",
  registerPageOfersPromotions: "Ofertes i promocions",
  registerPageOfersPromotionsDot: "Ofertes i promocions: ",
  registerPageOfersPromotionsAll: "ELS ACCEPTO TOTS",
  registerPageOfersPromotionsSome: "N’ACCEPTO ALGUNS",
  registerPageOfersPromotionsNone: "NO ELS ACCEPTO",
  registerPageOfersPromotionsPending: "PENDIENTE *",
  registerPagePersonalizeOptions:
    "Personalitzeu la vostra privacitat seleccionant les opcions següents:",
  registerPageIdentityVerifyTitle: "Confirma la teva identitat",
  registerPageIdentityVerifyText: "Per garantir la teva identitat, enviarem un codi de verificació a la teva adreça electrònica. Introduïu el codi a continuació per completar el procés de registre.",
  registerPageIdentityVerifyMailButton: "ENVIA CORREU ELECTRÒNIC",
  registerPageIdentityVerifyPhoneButton: "ENVIA SMS",
  registerPageIdentityVerifyVerificable:
    "Heu de realitzar una de les dues verificacions obligatòriament, l’altra la podeu ometre o aprofitar per realitzar-la",
  registerPageIdentityVerifyVerificableEmail:
    "La verificació de l’adreça electrònica és obligatòria",
  registerPageIdentityVerifyVerificablePhone:
    "La verificació del telèfon és obligatòria",
  registerPageIdentityVerifyNoVerificableEmail:
    "La verificació de l’adreça electrònica és opcional, podeu ometre aquest punt si voleu",
  registerPageIdentityVerifyNoVerificablePhone:
    "La verificació del telèfon és opcional, podeu ometre aquest punt si voleu",
  registerPageIdentityVerifyCodeSended: "Codi enviat",
  registerPageOtp: "Introduïu el codi",
  registerPageOtpError: "El codi introduït no és correcte",
  registerPageRegisterError: "Hi ha hagut un problema durant el registre",
  registerPageOfersPromotionsSelected: "Ofertes i promocions acceptades: ",
  registerPageOfersPromotionsSelectedAll: "Totes",
  registerPageOfersPromotionsSelectedSome: "Solo algunas",
  registerPageOfersPromotionsSelectedNone: "Cap",
  registerPageOfersPromotionsSelectedPending: "Sin seleccionar",
  registerPageSeeOfersPromotions: "Obre ofertes/promocions",
  registerPageSendOTP: "Introduïu el codi que us acabem d’enviar",
  registerPageSendOTPEmail: "Codi per a correu electrònic",
  registerPageSendOTPPhone: "Codi per a telèfon",
  registryTitleData: "Dades de registre",
  registerPagePersonType1: "Particular",
  registerPagePersonType2: "Empresa/Autònom",
  registerPageNoDocuments:
    "Per a aquest tipus d’empresa no es requereixen documents",
  registerPageWarnTitle: "Atención",
  registerPageWarnText: "El registro a correos ID ha ido correctamente, pero ha habido un problema en el guardado de datos, tendrás que volver a rellenarlos al acceder a la aplicación",
  registerPagePoliticsAndConditions: "Políticas y condiciones",
  registerPageRecaptcha: "Captcha",
  registerPageRecaptchaError: "Has de completar el captcha",

  //ChooseEnterpriseDialog

  chooseEnterpriseDialogTitle: "Selecciona l'empresa amb la qual vols accedir",
  chooseEnterpriseDialogSelectText: "Les empreses amb '*' són les que tens subscrites a l'aplicació",
  chooseEnterpriseDialogText1: "Aquestes són les teves empreses ",
  chooseEnterpriseDialogSubscribed: "subscrites",
  chooseEnterpriseDialogNoSubscribed: "no subscrites",
  chooseEnterpriseDialogText2: " a l'aplicació",

  //Stepper

  createUserCid: "Crear cuenta en CorreosID",
  userIdentify: "Verifica tu identidad",
  userIdentity: "Introduce tu identidad",
  sendOTP: "Envia el codi",
  reSendOTP: "Reenvia el codi",
  codeConfirm: "Confirma el codi",
  subscriptionToApp: "Suscripción a {appName}",
  ownerData: "Datos del titular",
  enterpriseCreation: "Creación de empresa",
  userData: "Datos de usuario",
  stepChangePass: "Canvia la contrasenya",
  enterpriseData: "Dades d’empresa",
  enterpriseDocuments: "Afegeix documents",
  requiredData: "Datos requeridos",
  createUserCidTextLabel: "Introduce tu email de acceso y contraseña, acepta las políticas de privacidad y crea una cuenta en CorreosID para acceder a nuestros servicios de forma segura.",
  userIdentifyTextLabel: "Este paso es esencial para verificar tu identidad y garantizar la seguridad de tus datos.",
  userIdentityTextLabel: "Ingresa los detalles de tu identidad. Estos detalles nos ayudarán a personalizar tu experiencia y a brindarte un mejor servicio.",
  sendOTPTextLabel: "Te enviaremos un código único a tu dirección de correo electrónico o número de teléfono. Utiliza este código para verificar que tienes acceso a los medios de contacto proporcionados.",
  reSendOTPTextLabel: "En caso de no haber recibido el código, tienes la opción de solicitar su reenvío. Verifica tu carpeta de correo no deseado antes de hacerlo.",
  codeConfirmTextLabel: "Ingresa el código que has recibido y confirma tu acceso. Este código garantiza que eres el titular de la cuenta y estás listo para proceder.",
  subscriptionToAppTextLabel: "Opta por suscribirte a nuestra aplicación para acceder a sus funciones exclusivas. Mantente al tanto de las últimas actualizaciones y novedades.",
  ownerDataTextLabel: "Proporciona información detallada sobre ti.",
  enterpriseCreationTextLabel: "Si estás creando una empresa, completa los pasos necesarios para registrarla oficialmente. Proporciona información sobre ella.",
  userDataTextLabel: "Proporciona información adicional sobre ti para enriquecer tu perfil.",
  stepChangePassTextLabel: "Si deseas cambiar tu contraseña actual, este es el momento para hacerlo. Proporciona una nueva contraseña segura y asegúrate de guardarla en un lugar seguro.",
  enterpriseDataTextLabel: "Si estás registrando una empresa, completa los detalles adicionales.",
  enterpriseDocumentsTextLabel: "Sube documentos importantes relacionados con tu empresa.",
  requiredDataTextLabel: "Asegúrate de proporcionar todos los datos necesarios para completar el proceso. Estos pueden variar según el tipo de cuenta que estás creando. Verifica cada sección cuidadosamente.",

  //ResetPassword

  resetPasswordTitle: "¿Has olvidado tu contraseña?",
  resetPasswordText: "No te preocupes, ¡puede pasarle a cualquiera!",
  resetPasswordFormatError: "8-16 carácteres, que contengan 3 de los 4 siguientes: minúsculas, mayúsculas, dígitos (0-9), y uno o más de los siguientes símbolos: @ # $ % ^ & * - _ + = [ ] { } | \\ : ' , ? / ` ~ ( ) ; . \"",
  resetPasswordCheckError: "Las contraseñas no son iguales",
  resetPasswordTitle2: "Cambia tu contraseña",
  resetPasswordText2: "Confirma tu identidad con el código que te hemos enviado a:",
  lAddUser:
    "Introduïu la vostra identitat de Correos i us ajudarem a crear una contrasenya nova.",
  backButton: "Torna",
  sending: "S’està enviant...",
  lAddOtp: "Necessitem saber que sou vós. Ens ho confirmeu?",
  lOtp: "Codi de verificació",
  emptyError: "El camp no pot estar buit.",
  emptyErrorPass: "Els camps no poden estar buits.",
  emptyErrorIdentifier: "Heu d’afegir un identificador de Correos vàlid.",
  lChangePass: "Escriviu la nova contrasenya.",
  lPass: "Contrasenya",
  lRPass: "Repetiu la contrasenya",
  errorEqualPass: "Les contrasenyes han de ser iguals",
  errorCheckPass: "La contrasenya indicada no és vàlida.",
  lCFinalStep: "La contrasenya s’ha modificat correctament.",
  lEFinalStep:
    "Error en canviar la contrasenya, torneu a intentar-ho d’aquí a uns minuts.",
  lStart: "Inicia",
  tLinkHelper: "Necessiteu ajuda?",
  hAddUser:
    "Per poder canviar la contrasenya necessitem saber l’identificador amb què us vau donar d’alta a la nostra plataforma.",
  hAddOtp:
    "Des de Correos ID necessitem verificar que sou vós qui està intentant canviar la contrasenya, per aquest motiu, us enviarem al vostre identificador de compte (telèfon o correu electrònic) un codi de 5 dígits. Simplement ens heu de dir aquest codi i podrem continuar amb el procés.",
  hAddPass:
    "Heu d’indicar una contrasenya nova que tingui entre 8-16 caràcters, que continguin tres dels quatre valors següents: minúscules, majúscules, dígits (0-9) i un o més dels símbols següents: @ # $ % ^ & * - _ + = [ ] { } |  : ' , ? / ` ~ \" ( ) ; .els mínims necessaris per poder continuar.",
  dialogClose: "Tanca",
  otpRpError: "El codi indicat no és correcte.",
  otpInvalidError: "OTP no vàlid",
  otpEmptyError: "El codi no pot estar buit.",

  //PrefixPhone

  prefixSelector: "Prefix",

  //UserData

  userDataInfo:
    "Ja tens compte a CorreosId, ara és el moment de subscriure't a {appName}",
  userDataInfoCid:
    "T'has registrat a CorreosId correctament, ara cal completar les dades requerides",
  userDataVerifyEmailOk: "L’adreça electrònica s’ha verificat correctament",
  userDataVerifyEmailKo:
    "Hi ha hagut un problema amb la verificació de l’adreça electrònica",
  userDataVerifyPhoneOk: "El telèfon s’ha verificat correctament",
  userDataVerifyPhoneKo:
    "Hi ha hagut un problema amb la verificació del telèfon",
  userDataInfoQuestion: "¿Seguro que deseas cancelar la suscripción a {appName}?",
  userDataInfoQuestionCid: "¿Seguro que deseas cancelar la creación de la empresa?",
  userDataExitInfo:
    "Ya estás registrado en correosID, ten en cuenta que si sales ahora cuando hagas login en {appName} tendrás que terminar de rellenar los datos para suscribirte.",
  userDataExitInfoCid:
    "Ya estás registrado en correosID, ten en cuenta que si sales ahora tu usuario no tendrá empresa",
  userDataCopyDirection: "Copia l’adreça",
  userDataSuccessUpdate: "Dades d’usuari actualitzades correctament",
  userDataAddEmail: "Afegeix adreça electrònica",
  userDataModifyEmailTitle: "Canviar correu electrònic",
  userDataVerifyEmailTitle: "Verificar correu electrònic",
  userDataDeleteEmail: "Eliminar email",
  userDataDeleteEmailSuccess: "Email eliminado",
  userDataAddPhone: "Afegeix telèfon",
  userDataModifyPhoneTitle: "Canviar telèfon",
  userDataVerifyPhoneTitle: "Verificar telèfon",
  userDataDeletePhone: "Eliminar telèfon",
  userDataDeletePhoneSuccess: "Telèfon eliminat",
  userDataAddDoc: "Afegeix document",
  userDataModifyDoc: "Modificar document identificatiu",
  userDataDeleteDoc: "Eliminar document identificatiu",
  userDataAddDocSuccess: "Document identificatiu afegit",
  userDataModifyDocSuccess: "Document identificatiu modificat",
  userDataDeleteDocSuccess: "Document identificatiu eliminat",
  userDataAddAddress: "Afegeix adreça",
  userDataModifyAddress: "Modificar adreça",
  userDataDeleteAddress: "Eliminar adreça",
  userDataAddAddressSuccess: "Adreça afegida",
  userDataModifyAddressSuccess: "Adreça modificada",
  userDataDeleteAddressSuccess: "Adreça eliminada",
  userDataSaveWarning:
    "Recordeu desar les dades perquè aquest canvi tingui efecte",
  userDataAliasWarning: "Ja tens una adreça amb aquest nom",
  userDataAddDirection: "Voleu afegir una adreça amb les dades actuals?",
  userDataAddDirectionMandatorie:
    "Per poder afegir una adreça, heu d’emplenar tots els camps obligatoris",
  userDataRequiredDirection: "L’àlies i l’adreça són camps obligatoris",
  userDataAddDirectionSuccess:
    "Adreça afegida correctament",
  userDataChangeDirectionSuccess: "Dirección modificada con éxito",
  userDataFavouriteDirection: "Dirección favorita",
  userDataFavouriteDirectionWarning: "Ya tienes una dirección favorita y sólo puedes tener una, si seleccionas esta la otra dejará de serlo",
  userDataWarningMessage:
    "Recordeu que per desar una adreça nova, abans l’heu d’afegir a la llista; si no ho heu fet encara premeu Cancel·la i afegiu la nova adreça abans de continuar",
  userDataRegister: "Registro completado",
  userDataIncomplete:
    "Hi falten dades obligatòries. Si us plau, empleneu les dades obligatòries que hi falten.",
  userDataFNAError: "La data de naixement no pot ser posterior al dia d’avui.",
  userDataSaveProfile: "Guardar perfil",
  enterpriseDataSaveProfile: "Guardar empresa",
  userDataAddressUpdateWarning: "Cal actualitzar aquesta adreça perquè les vostres dades no són correctes",
  userDataPageSubtitle: "Edita les teves dades personals i gestiona les teves adreces. Tingues en compte que podràs afegir un màxim de 3 correus electrònics, telèfons i adreces.",
  userFormatIncorrect: "Formato no soportado. Solo se permiten letras y hasta un máximo de 50 caracteres.",
  userDataVerifyEmail: "T'enviarem un codi de verificació al teu correu electrònic per confirmar que ets el propietari del compte. Introdueix el codi a continuació per completar el procés de verificació.",
  userDataInternationalPhoneWarning: "El prefix seleccionat no és vàlid per a la seva verificació en el nostre servei. Si us plau, selecciona un prefix vàlid.",
  userDataModifyEmail: "T'enviarem un codi de verificació al teu nou correu electrònic per confirmar que ets el propietari del compte. Introdueix el codi a continuació per completar el canvi de correu electrònic.",
  userDataVerifyPhone: "Te enviaremos un código de verificación a tu teléfono para confirmar que eres el propietario de éste. Introduce el código a continuación para completar el proceso de verificación.",
  userDataModifyPhone: "Te enviaremos un código de verificación a tu nuevo teléfono para confirmar que eres el propietario de éste. Introduce el código a continuación para completar el cambio de teléfono.",


  //EnterpriseData

  enterpriseDataInfo:
    "S’ha efectuat el registre correctament, ara és necessari acabar d’emplenar les dades de l’empresa",
  enterpriseDataInfoQuestion:
    "Segur que voleu cancel·lar la inserció de dades?",
  enterpriseDataExitInfo:
    "L’empresa ja ha estat registrada, si sortiu sense proporcionar les dades se us tornaran a demanar quan torneu a accedir-hi",
  enterpriseDataCopyDirection: "Copia l’adreça",
  enterpriseDataSuccessUpdate: "Dades d’empresa actualitzades correctament",
  enterpriseDataAddressWarning: "La dirección se guardará junto con la creación de la empresa",
  enterpriseDataCreated: "Empresa creada correctament",
  enterpriseDataSaveData: "Guardar datos",
  enterpriseDataPageSubtitle: "Modifica los datos de tu empresa así como la dirección fiscal",
  enterpriseDataCreatePageSubtitle: "Añade los datos de tu empresa así como la dirección fiscal",
  enterpriseDataSave: "Guardar empresa",
  enterpriseDataCreate: "Crear empresa",
  enterpriseDataCreateNameExists: "Ja tens una empresa amb aquest nom",

  //DialogAddChange
  dialogAddChangeAddTitle: "Afegir adreça",
  dialogAddChangeChangeTitle: "Modificar adreça",
  dialogAddChangeAddText: "Afegeix les dades de l'adreça",
  dialogAddChangeChangeText: "Modifica les dades de l'adreça",

  //Main

  userNameUnregistered: "Usuari sense nom",
  enterpriseNameUnregistered: "Empresa sense nom",
  mainPageTitle: "Benvingut a Correos ID",
  mainPageUserProfile: "Perfil d’usuari",
  mainPagePrivacity: "Privacitat",
  mainPageVerifications: "Verificacions",
  mainPageCreateEnterprise: "Crea empresa",
  mainPageAvailableServices: "Serveis subscrits",

  //SideBar

  UserData: "Dades",
  UserVerifications: "Verificacions",
  UserPrivacy: "Privacitat",
  EnterpriseCreate: "Crea",
  EnterpriseTeam: "Equip",
  EnterpriseDelete: "Sol·licita la baixa",
  UserServices: "Particular",
  EnterpriseData: "Dades",
  EnterpriseVerifications: "Verificacions",
  EnterprisePrivacy: "Privacitat",
  EnterpriseServices: "Empresa",
  User: "Usuari",
  Enterprise: "Empresa",
  Services: "Serveis",
  Service: "Servicio",
  profileComp: "Progrés del perfil",
  SystemUser: "Aplicacions",

  //Service Page

  subscribeService: "Subscriu-t’hi",
  unsubscribeService: "Baixa",
  revokeData: "Retira l’accés a les meves dades",
  acceptData: "Permet l’accés a les meves dades",
  goToService: "Entrar",
  subscribedService: "Subscrit",
  unSubscribedService: "No subscrit",
  askUnsubscribeService: "Sol·licita la baixa",
  serviceSubscribed: "Subscripció realitzada correctament",
  serviceUnsubscribed: "Cancel·lació de la subscripció realitzada correctament",
  revokeEnterpriseData: "Retira permisos",
  acceptEnterpriseData: "Permet permisos",
  servicePageDualWarning: "¿Seguro que quieres darte de baja de {applicationName}?",
  servicePageCancelAccount: "Usuario",
  servicePageCancelEnterprise: "Empresa",
  servicePageUnsubscribe: "Servicio",
  singleSubscriptionDialogRedirectTextUser: "Estás a punto de darte de baja de {applicationName}, que es tu único servicio. Si deseas continuar con esta acción, pulsa en 'Servicio'. Por otro lado, si lo que quieres es dar de baja tu usuario de Correos ID, pulsa en 'Usuario'.",
  singleSubscriptionDialogRedirectTextEnterprise: "Estás a punto de dar de baja la empresa de {applicationName}, que es su único servicio. Si deseas continuar con esta acción, pulsa en 'Servicio'. Por otro lado, si lo que quieres es dar de baja la empresa, pulsa en 'Empresa'.",
  servicePageLinkText: "enllaç",
  subscribeMeText: "Subscriure'm",
  subscriptionOkTitle: "A punt!",
  subscriptionOkText: "T'has subscrit amb èxit",
  servicePageSubtitle: "Subscriu-te als serveis digitals de Correos utilitzant la teva identitat de Correos ID.",
  servicePageEnterpriseSubtitle: "Subscriu la teva empresa als serveis digitals de Correos.",
  servicePageAppGoTo: "Suscríbete desde el servicio",
  servicePageAppAccess: "Accede desde el servicio",
  servicePageConfirmCancelAccount: "¿Seguro que quieres cancelar tu cuenta?",
  servicePageConfirmCancelEnterprise: "¿Seguro que quieres eliminar la empresa?",

  //Verifitacions Page

  verificationsVerify: "Verifica",
  verificated: "Verificat",
  notVerificated: "No verificat",
  pendingVerificated: "Pendent",
  UserEmail: "Adreça electrònica",
  PersonaTelfMovil: "Telèfon",
  PersonaNumDocID: "Núm. document",
  PersonaDireccion: "Adreça",
  verificationsSendCode: "Enviarem un codi de verificació a: ",
  verificationsVerifyEmail: "Verifica el teu correu electrònic",
  verificationsVerifyPhone: "Verifica el teu telèfon",
  verificationsChangeEmail: "Canvia el teu correu electrònic",
  verificationsChangePhone: "Canvia el teu telèfon",
  verificationsConfirmCode: "Introduïu el codi de verificació",
  verificationsVerificationType: "Tipus de verificació",
  verificationsConfirmPostCard:
    "Us enviarem el codi per correu postal, segur que voleu fer aquest tipus de verificació?",
  verificationsCreate: "Introduïu les dades per afegir ",
  verificationsAlias: "Àlies",
  verificationsCountry: "País o regió",
  verificationsDirection: "Adreça",
  verificationsPostalCode: "Codi Postal",
  verificationsRegion: "Província/Regió",
  verificationsTown: "Població",
  verificatinosDeleteElement: "Voleu eliminar l’element?",
  verificationsVerifiedData: "Dades verificades",
  verificationsEMA: "Adreces electròniques verificades",
  verificationsMOV: "Telèfons verificats",
  verificationsNDO: "Documents verificats",
  verificationsALI: "Adreces verificades",
  verificationsEmpty: "Cap",
  verificationsUpgrade: "Aumentar nivel de verificación",
  verificationsAddEmail: "Adreça electrònica afegida correctament",
  verificationsVerifyEmailSuccess: "Correu electrònic verificat correctament",
  verificationsChangeEmailSuccess: "Correu electrònic canviat correctament",
  verificationsDeleteEmail: "Correu electrònic eliminat correctament",
  verificationsAddPhone: "Telèfon afegit correctament",
  verificationsVerifyPhoneSuccess: "Telèfon verificat correctament",
  verificationsChangePhoneSuccess: "Telèfon canviat correctament",
  verificationsDeletePhone: "Telèfon eliminat correctament",
  verificationsAddAddress: "Adreça afegida correctament",
  verificationsVerifyAddressSuccess: "Adreça verificada correctament",
  verificationsDeleteAddress: "Adreça eliminada correctament",
  verificationsDeleteDocument: "Document eliminat correctament",
  verificationsDeleteAddressTooltip: "Eliminar adreça",
  verificationsDocuments: "Documentació",
  verificationsemail: "Adreça electrònica",
  verificationsphone: "Telèfon",
  verificationsaddress: "Adreça",
  verificationsnumber: "Document identificatiu",
  verificationsByOtp: "Verificat per codi",
  verificationsByForm: "Verificat per format",
  verificationsReSendOtp: "Codi reenviat",
  verificationDisableAccountTitle:
    "Si us doneu de baixa de Correos ID deixareu de tenir accés a tots els serveis que es mostren a continuació:",
  verificationDisableAccountList: "Esborrarem el vostre compte*.",
  verificationDisableAccountP1:
    "Us aconsellem que abans d’eliminar el compte de Correos ID sol·liciteu i finalitzeu la baixa en els serveis en què esteu registrat. Per a això, seleccioneu l’opció Cancel·la. Si tot i així continueu preferint eliminar ara el vostre compte de Correos ID, cliqueu “Dona de baixa”.",
  verificationDisableAccountP2:
    "*Tranquil, teniu {disableAccDays} dies per recuperar el compte de Correos ID, per si us en penediu. Podreu recuperar el compte de Correos ID, però la resta de serveis poden no desar les vostres dades durant aquests {disableAccDays} dies.",
  verificationDisableAccountP3:
    "Correos ID comunicarà l’eliminació del compte als serveis associats, però l’eliminació del compte en cada servei no és responsabilitat de Correos ID",
  verificationDisableAccountConfirm: "Dona de baixa",
  verificationsWrongTipeDocument: "El tipus de document no és vàlid",
  verificationsUploadSuccess: "Document pujat correctament",
  verificationsDeleteSuccess: "Document eliminat correctament",
  verificationsNoUploaded: "No pujat",
  verificationsEmailExists: "L’adreça electrònica introduïda ja existeix",
  verificationsPhoneExists: "El telèfon introduït ja existeix",
  verificationsUnifyUserTitle: "Atención",
  verificationsUnifyUserText: "Hemos detectado que el {dataType} que estás intentando verificar ya existe en otra cuenta. ¿Es este {dataType} ({data}) realmente tuyo?. Si es así pulsa en 'Aceptar' para unificar ambas cuentas",
  verificationsPageSubtitle: "Podeu gestionar i verificar les vostres dades, així com canviar la vostra contrasenya d'accés.",
  verificationsEnterprisePageSubtitle: "Pots gestionar i verificar les dades de l'empresa.",
  verificationsDeleteLastEmail: "No pots eliminar l'últim correu electrònic verificat",
};
